import { createDrawingObject, replacePoint } from "../shared";
const Polygon = {
    name: "polygon",
    createDraft: (startPoint) => createDrawingObject("polygon", [startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replacePoint(draft, draft.points.length - 1, nextPoint),
    render: () => undefined,
};
export default Polygon;
